export default __webpack_public_path__ + "static/media/trm-home.9057f0ce.png";